import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar } from '@inmoment/the-kitchen';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example', 'LRPickerObject', 'LRPickerItem'].map(convertArrayToTabBar);

export const LeftRightPickerDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('Example');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <div>
      <p className="kxi-text-300 kxi-text-normal">LeftRightPicker Data</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
      </div>
      {tab === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`[
  initialAvailableItems: [
    {
      id: '0',
      title: 'Abelisaurus',
      disabled: false,
      searchTags: ['dinosaurs'],
    },
    {
      id: '1',
      title: 'Mount Katmai',
      disabled: false,
      searchTags: ['volcanos'],
    }
  ],
  initialSelectedItems: [
      id: '3',
      title: 'Baryonyx',
      disabled: true,
      tooltip: 'Baryonyx is not in user group.',
      searchTags: ['volcanos'],
  },
  {
    title: "disabled tab 3",
    id: 2,
    disabled: true
  }
]`}
        />
      )}
      {tab === 'LRPickerObject' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface LRPickerObject {
  initialAvailableItems: LRPickerItem[];
  initialSelectedItems?: LRPickerItem[];
}`}
        />
      )}
      {tab === 'LRPickerItem' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface LRPickerItem {
  title: string;
  component?: any;
  disabled?: boolean;
  tooltip?: string;
  searchTags?: string[];
  id: string | number;
}`}
        />
      )}
      <br />
    </div>
  );
};
